<!-- 优惠券模块 -->
<template>
	<div class="index-coupon" :style="{backgroundColor:couponData.bg_color}">
		<div v-for="(coupon,index) in couponData.coupon" :key="index" :class="'coupon-detail-'+couponData.coupon_type">
			<div class='product-item' @click="exchangeCoupon(coupon.id)">
				<template v-if="coupon.is_receive == 1">
					<el-image
						class="product-proImg"
						style="width: 100%;"
						:src="coupon.claim_image"
						fit="contain">
					</el-image>
				</template>
				<template v-else>
					<el-image
						class="product-proImg"
						style="width: 100%;"
						:src="coupon.unclaimed_image"
						fit="contain">
					</el-image>
				</template>

			</div>
		</div>
	</div>
</template>
<script>
export default {
	name:'coupon',
	props:{
		couponData:{
			type:Object,
		},
	},
	methods:{
		exchangeCoupon(id){
			console.log(id);
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/mode/coupon.vue